var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.074 36.1112C49.074 41.7363 44.5139 46.2964 38.8888 46.2964H23.1481C17.523 46.2964 12.9629 41.7363 12.9629 36.1112L12.9629 4.62972H49.074V36.1112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0.925781 21.7593C0.925781 15.9978 5.35103 11.2738 10.8268 11.1153L11.111 11.1112V14.9336C7.52421 14.9336 4.582 18.0095 4.582 21.7593C4.582 25.4258 7.3949 28.448 10.8728 28.5805L11.111 28.5851V32.4075C5.50494 32.4075 0.925781 27.6202 0.925781 21.7593Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMug);
export default __webpack_public_path__ + "static/media/mug.d423683d9deba629086fd09215b000e1.svg";
export { ForwardRef as ReactComponent };